'use client';
import PropTypes from 'prop-types';
import * as React from 'react';
import { Box } from '../box/box.component.js';
import { Link } from '../link/link.component.js';
import { createComponent } from '../core/create-component.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { FlexBox } from '../flex-box/flex-box.component.js';

const propTypes = {
    /**
   * The number of stars to be filled and the number shown, can have one decimal place
   * @default 0
   */ ratingValue: PropTypes.number.isRequired,
    /**
   * Hides the numeric rating
   * @default false
   */ hideRating: PropTypes.bool,
    /**
   * The amount of reviews
   */ reviews: PropTypes.number,
    /**
   * The link to the reviews
   */ href: PropTypes.string,
    /**
   * The visual style of the Rating Stars
   * @default standard
   */ skin: PropTypes.oneOf([
        'standard',
        'monochromatic'
    ])
};
const RatingsStars = createComponent({
    displayName: 'RatingsStars',
    root: 'div',
    propTypes,
    requiredStyleKeys: SWAN_STYLE_KEY_MAP.ratingsStars,
    propConfig: {
        classNames (props) {
            const classesSet = new Set([
                'swan-ratings'
            ]);
            if (props.skin && props.skin !== 'standard') classesSet.add(`swan-ratings-skin-${props.skin}`);
            return classesSet;
        },
        wrapChildren ({ ratingValue, reviews, href, hideRating = false, 'aria-label': ariaLabel }) {
            const [ratingInteger, ratingFractional] = ratingValue.toFixed(1).split('.').map((u)=>Number(u)) // Normalizing to one decimal place
            ;
            return /*#__PURE__*/ React.createElement(FlexBox, {
                className: "swan-ratings-stars-container",
                alignItems: 'center',
                gap: 2
            }, /*#__PURE__*/ React.createElement(Box, {
                className: "swan-ratings-stars",
                role: "img",
                "aria-label": ariaLabel
            }, Array.from({
                length: 5
            }).map((_, idx)=>{
                const ratingClasses = [
                    'swan-ratings-star'
                ];
                if (idx + 1 <= ratingInteger) ratingClasses.push('swan-ratings-star-filled');
                if ((ratingFractional && idx + 1) === ratingInteger + 1) ratingClasses.push(`swan-ratings-star-filled-p${ratingFractional}`);
                // eslint-disable-next-line react/no-array-index-key
                return /*#__PURE__*/ React.createElement("span", {
                    key: `star_${idx}`,
                    className: ratingClasses.join(' ')
                });
            })), !hideRating && /*#__PURE__*/ React.createElement("span", {
                className: "swan-ratings-stars-rating"
            }, ratingValue), reviews !== undefined && reviews !== null && /*#__PURE__*/ React.createElement("span", {
                className: "swan-ratings-stars-reviews"
            }, "(", href ? /*#__PURE__*/ React.createElement(Link, {
                to: href
            }, reviews) : reviews, ")"));
        }
    }
});

export { RatingsStars };
